// extracted by mini-css-extract-plugin
export default {"spinner":"spinner___spinner___3_Hu0","spinner--black":"spinner___spinner--black___2qXcF","spin-cycle":"spinner___spin-cycle___LvhNr"};